<style scoped>
th, td {
  padding: 4px;
  text-align: center;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.12);
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
  <div v-loading="loading">
    <mu-button
      icon
      class="float-right"
      @click="$emit('close')"
      >
      <mu-icon value="close" />
    </mu-button>
    <mu-card-text>
      <h2>{{$t('AnalyticsCompletion.title')}}</h2>
    </mu-card-text>
    <div v-if="data.length > 0">
      <chart 
        :option="chartOption" 
        id="AnalyticsCompletion" 
        height="300px" 
        />
      <table width="100%;">
        <tr>
          <th v-for="column in columns">
              {{column.title}}
          </th>
        </tr>
        <tr v-for="row in data">
          <td>{{row.user.name}} <br />{{row.user.email}}</td>
          <td>{{Math.round(row.rate)}}%</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import theme from '@/mixins/theme.js'

import chart from '@/components/Charts/Charts.vue'
import echarts from 'echarts'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: 'AnalyticsCompletion',
  props: ["media"],
  mixins: [theme],
  components: {
    chart,
  },
  data() {
    return {
      data: [],
      loading: false,
      columns: [
        { title: this.$t('AnalyticsCompletion.user'), name: 'user' },
        { title: this.$t('AnalyticsCompletion.rate.display'), name: 'rate' },
      ],
    };
  },
  watch: {
  
  },
  computed: {
    legends() {
      return [
        this.$t('AnalyticsCompletion.rate.notYetStarted'),
        this.$t('AnalyticsCompletion.rate.incomplete'),
        this.$t('AnalyticsCompletion.rate.completed')
      ];
    },
    notYetStartedCount() {
      var sum = 0;
      this.data.forEach(i => {
        if(i.rate === 0) {
          sum++;
        }
      });
      return sum;
    },
    incompleteCount() {
      var sum = 0;
      this.data.forEach(i => {
        if(i.rate > 0 && i.rate < 95) {
          sum++;
        }
      });
      return sum;
    },
    completedCount() {
      var sum = 0;
      this.data.forEach(i => {
        if(i.rate >= 95) {
          sum++;
        }
      });
      return sum;
    },
    chartOption() {
      return {
        title : {
          text: this.$t('AnalyticsCompletion.titleWithName', { name: this.media.name }),
          x: 'center',
          textStyle: {
            fontSize: 12
          }
        },
        tooltip : {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          x : 'center',
          y : 'bottom',
          data: this.legends
        },
        calculable : true,
        series : [
          {
            name: this.$t('AnalyticsCompletion.userNo'),
            type: 'pie',
            radius : [20, 100],
            roseType : 'radius',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: true
              }
            },
            lableLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: true
              }
            },
            data:[
              {value: this.notYetStartedCount, name: this.$t('AnalyticsCompletion.rate.notYetStarted')},
              {value: this.incompleteCount, name: this.$t('AnalyticsCompletion.rate.incomplete')},
              {value: this.completedCount, name: this.$t('AnalyticsCompletion.rate.completed')},
            ]
          },
        ]
      }
    },
  },
  mounted() {
    this.getData(this.media._id);
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  methods: {
    getData(mediaId) {
      this.loading = true;
      axios
      .get(this.$store.getters.urlApi + "analytics/completion/media/" + mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      })
      .then(response => {
        this.data = response.data.data.data;
        this.loading = false;
      });
    },
  },
};
</script>
